import React, { useEffect, useMemo, useState } from 'react';
import {Stack, Typography } from '@mui/material';
import { StyledDiv, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled/index';
import { privateRoutesPath } from '../../Routes';
import moment from 'moment';
import {Button} from '@mui/material';
import DataGridTable from '../../Components/DataGrid';
import SearchInvoice from './SearchInvoice';
import './invoice.css';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIVE_STATUS, ARRAY_SERIALIZER, handleValidateCodevalue, INVOICE_STATUS, nameWidth, productIdWidth, salesOrderIdWidth, searchEntity, statusWidth, whocolumnWidth } from '../../Utility/constant';
import { useSnackbar } from 'notistack';
import LeadDialog from '../../Components/LeadDialog';
import BiztantuSearch from '../../Components/BiztantuSearch';
import { requestGetAllInvoices } from '../../Store/Invoice/action';
import { requestGetAllCustomers } from '../../Store/Customer/action';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import BiztantuLoader from '../../Components/Loader';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { useSearchExecutor } from '../../Components/CustomHooks/useSearchExecutor';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { resetSearch, setSearch } from '../../Store/SearchReducer/action';
import { resetState } from '../../Utility/resetSearchFunction';
import { buildEntitySearchValues } from '../../Utility/buildEntitySearchValues ';
import { useEntitySearch } from '../../Utility/hooks/useEntitySearch';
import { updateRequestData } from '../../Utility/apiHelper';
import useNavigation from '../../Utility/hooks/useNavigation';

const InvoicePage = (props) => {
  const [dataGridData, setDatagridData] = useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [selectionModel, setSelectionModel] = React.useState([]);
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  const customerdropdown = useSelector(state=> state?.customer?.customer)
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  const [isOpenDialog , setIsOpenDialog] = useState(false);
  const [selectedowner, setSelectedOwner] = useState("");
  const [ownerlistdropdown, setownerlistdropdown] = useState([]);
  const ownerlist = useSelector(state => state?.owner?.ownerlist);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const currentUser = useSelector(state => state?.owner?.currentuser);
  const dispatch = useDispatch();
  const invoiceData = useSelector(state => state?.invoice?.invoice)
  const invoiceStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == INVOICE_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);  

  const { navigateTo } = useNavigation();
  const myTeam = useSelector(state => state?.owner?.Team);
  
      const today = new Date();
      const daysAgo = new Date();
      daysAgo.setDate(today.getDate() - 90);
      
      const invoiceSearch = useSelector((state) => state?.search?.invoice) || {};
      

  useEffect(() => {
    dispatch(requestGetAllCustomers());
  }, []);

  
    useEffect(() => {
      const updatedLeadTable = (invoiceData || [])?.map((item,index)=>{
        return {
          ...item,
        }
      })
      setDatagridData(updatedLeadTable);
    }, [invoiceData]);


  const isReady =
    (myTeam?.length > 0  ||
    ownerlist?.length > 0) &&
    currentUser?.userId &&
    internationalise &&
    Object.keys(internationalise).length > 0;
  
              const { updatedSearch, newList } = useMemo(() => 
                      buildEntitySearchValues({
                          entity: searchEntity?.invoice,
                          currentUser,
                          specificRolePermission,
                          ownerlist,
                          myTeam,
                          daysAgo,
                          today,
                          isAllManage: specificRolePermission?.isAllInvoiceManage,
                          isTeamManage: specificRolePermission?.isInvoiceTeamManage,
                          internationalise,
                          handleValidateCodevalue,
                      }), [currentUser, specificRolePermission, ownerlist, myTeam, internationalise]);
              
          const preserveSearch = useSelector(
            state => state?.search?.preserveSearch?.[searchEntity?.invoice]
          );
    
                  useEffect(() => {
              setownerlistdropdown(newList);
              }, [newList]);
          
              useEntitySearch({
                  entity: searchEntity?.invoice,
                  preserveSearch,
                  searchState: invoiceSearch,
                  isReady,
                  getInitialState: () => updatedSearch,
                  fetchAction: (search) =>
                  requestGetAllInvoices({
                      params: buildSearchParams(search),
                      paramsSerializer: ARRAY_SERIALIZER,
                  }),
                  });
  const currentOwnerId = useSelector(state => state?.owner?.currentuser?.userId);
  const currentOwner = ((specificRolePermission?.isAllInvoiceManage ? ownerlist : specificRolePermission?.isInvoiceTeamManage ? myTeam : ownerlist) || []).find(item=> item?.id === currentOwnerId)
  
  useEffect(()=>{
  setSelectedOwner(currentOwner)
  },[currentOwner])
  
  
         const handleChangeSearchField = (event) => {
                     dispatch(setSearch(searchEntity?.invoice, {
                         ...invoiceSearch,
                         [event.target.name]: event.target.value,
                     }));
                 };
             
  
      const handleResetSearch = () => {
        dispatch(
          resetSearch(searchEntity?.invoice,resetState(invoiceSearch, {
            selectedOwner: invoiceSearch?.selectedOwner,
            ownerId : invoiceSearch?.ownerId,
            ownerName: invoiceSearch?.ownerName
          })
        )
      );
    }


      
  const handleCloseDialog = () => {
      setIsOpenDialog(false);
      setSelectionModel([]);
      setSelectedOwner(currentOwner);
  }

  
    const handleSave = async () =>{
      const rowsData = dataGridData.filter(function(item){
          return selectionModel.indexOf(item.id) !== -1;
        });
  
        
        const reqPayload = rowsData.filter((item, index) => item?.owner != selectedowner?.id);
  
       const payload = reqPayload.map(item => {
          return {
            id: item?.id,
            ownerId: selectedowner?.id
          }
        })

      
const response = await updateRequestData(payload,"invoice/assign");

if (response?.status === "error") {
    enqueueSnackbar(
        handleValidateCodevalue(
            internationalise,
            response?.propererror?.data?.summary || "COMMON_PLEASE_TRY_AGAIN"
        ),
        { variant: "error" }
    );
    return;
}

enqueueSnackbar(
    `${response?.data?.success} ${handleValidateCodevalue(
        internationalise,
        "INVOICES_REASSIGNED_TO"
    )} ${
        ownerlist?.find(item => item?.id == selectedowner?.id)?.firstName
    } ${
        ownerlist?.find(item => item?.id == selectedowner?.id)?.lastName
    }`,
    { variant: "success" }
);

handleCloseDialog();
handleSearchInvoice();
    }
  const columns = [
    {
    field: 'id',
    headerName: handleValidateCodevalue(internationalise,'INV_SEARCH_INV_ID'),
    flex: 1,
    minWidth : productIdWidth,
    editable: false, 
    renderCell : ({id})=>(
      <span
      onClick={()=>handleViewInvoiceSlip(id)}
      className="invoice-id-link"
      >
        {id}
      </span>
    )
  },
    {
      field: 'orderId',
      headerName: handleValidateCodevalue(internationalise,'INV_SEARCH_ORD_ID'),
      flex: 1,
      minWidth : salesOrderIdWidth,
      editable: false,
    },
    {
      field: 'customerId',
      headerName: handleValidateCodevalue(internationalise,'INV_SEARCH_CUSTOMER'),
      flex: 1,
      minWidth : nameWidth,
      editable: false,
      valueGetter: ({ value }) => {
      if (!value) return '';
      const customer = customerdropdown?.find(c => c.id === value);
      return customer ? `${customer?.firstName || ''} ${customer?.lastName || ''}`.trim() : '';
      },  
    },
      {
        field: 'ownerId',
        headerName: handleValidateCodevalue(internationalise,'INV_SEARCH_OWNER'),
        flex: 1,
        minWidth : nameWidth,
        editable: false,
        valueGetter: ({ value }) => {
        const owner = ownerlistdropdown.find(c => c.id === value);
        return owner ? owner.name : '';
      },  
      },
    {
      field: 'status',
      headerName: handleValidateCodevalue(internationalise,'INV_SEARCH_STATUS'),
      flex: 1,
      minWidth : statusWidth,
      editable: false,
      valueGetter: ({ value }) => value ? handleValidateCodevalue(internationalise, value) : ''
    },
    {
      field: 'createdAt',
      headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
      type: 'date',
      flex: 1,
      minWidth : whocolumnWidth,
      editable: false,
      valueGetter: ({ value }) => value && moment(new Date(value)).format('MM/DD/YYYY'),
    },
    {
      field: 'updatedAt',
      type: 'date',
      headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
      flex: 1,
      minWidth : whocolumnWidth,
      editable: false,
      valueGetter: ({ value }) => value && moment(new Date(value)).format('MM/DD/YYYY'),
    },
  ];



  const handleViewInvoiceSlip = (id) => {
  navigateTo(`${privateRoutesPath.EDIT_INVOICE}/${id}`,{},searchEntity?.invoice);
};

 const {buildSearchParams,executeSearch} = useSearchExecutor({
    ownerlist,
    myTeam,
    enqueueSnackbar,
    internationalise,
    handleValidateCodevalue,
  });
  const handleSearchInvoice = async() => {
       dispatch(requestShowLoader())
const params = buildSearchParams(invoiceSearch);
    if (!params) return;

    executeSearch(requestGetAllInvoices, params);
       dispatch(requestHideLoader())
   };

  const handleUpdateInvoice = (rowRecord) => {
   
  }

  const invoiceSearchBox = {
    ...invoiceSearch
  }
    const handleSelectReassignOwner = (event, Owner) => {
            setSelectedOwner(Owner)

      }
    
    const handleSelectOwner = (event, Owner,entity) => {
    if(entity==="Customer"){
    dispatch(setSearch(searchEntity?.invoice, {
                    ...invoiceSearch,
                  selectedCustomer : Owner,
                  customerId : Owner?.id
            }));
        }
        else{
          if ((!Owner || Owner.length === 0) && !specificRolePermission?.isAllInvoiceManage) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_SELECT_OWNER_WARNING"), { variant: "warning" });
            return;
          }
          dispatch(setSearch(searchEntity?.invoice, {
            ...invoiceSearch,
            selectedOwner: Owner,
            ownerId : Owner?.id,
            ownerName: Owner?.name
          }));
      }
        }

  const handleSelectAutocomplete = (e,value,name) => {
    dispatch(setSearch(searchEntity?.invoice, {
       ...invoiceSearch,
      [name] : value
    }));
  }
    const isLoadingProgress = useSelector(state => state?.global.isLoading); 
  return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
    <StyledDiv>
      <StyledLeadContainer>
        <Typography variant='h6' className='mb-20'>
        {handleValidateCodevalue(internationalise,'INV_SEARCH_TITLE')}         
        </Typography>
        <Stack>
        </Stack>
        </StyledLeadContainer>
      {/* <SearchInvoice 
        handleSearchInvoice={handleSearchInvoice}
        customerdropdown={customerdropdown}
      /> */}

      <StyledIndexContainerDiv>
            <StyledLeadContainer className="invoice-search-panel">
                <Stack className='table-header-search table-header-search-common'>
                  <BiztantuSearch
                    showStatus = {false}
                    showOwner = {true}
                    entityDetails = {invoiceSearchBox}
                    ownerlistdropdown = {ownerlistdropdown}
                    handleReset = {handleResetSearch}
                    handleSearch = {handleSearchInvoice}>
                    <SearchInvoice
                      handleSelectStatus = {handleSelectAutocomplete}
                      handleSelectOwner = {handleSelectOwner}
                      handleResetSearch ={handleResetSearch}
                      customerdropdown={customerdropdown}
                      ownerlistdropdown = {ownerlistdropdown}
                      entityDetails = {invoiceSearch}
                      handleOnChange = {handleChangeSearchField}
                    />
                  </BiztantuSearch>
                </Stack>
                <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                {specificRolePermission?.isInvoiceManage &&
                <Button className='biztantu-sec-btn' variant="outlined" onClick={() => 
                      navigateTo(privateRoutesPath.CREATE_INVOICE,{},searchEntity?.invoice)}>
                        {handleValidateCodevalue(internationalise,"INV_CREATE")}</Button>
                }
                </Stack>
            </StyledLeadContainer>
      <StyledLeadContainer>
        <DataGridTable
          isInvoiceScreen = {true}
          height='calc(100vh - 218px)'
          setIsOpenDialog={setIsOpenDialog}
          dataGridData={dataGridData}
          filename="invoice"
          columns={columns}
          rowModesModel={rowModesModel}
          handleUpdateCustomer={handleUpdateInvoice}
          selectionModel={selectionModel}
          setSelectionModel={(data) => setSelectionModel(data)}
        />
       </StyledLeadContainer>
    </StyledIndexContainerDiv>
      
    
        {isOpenDialog && 
        (
                            <LeadDialog
                                open = {isOpenDialog}
                                handleClose = {handleCloseDialog}
                                title= {handleValidateCodevalue(internationalise,"INV_REASSIGN_TITLE")}
                                size="sm"
                                selectedowner={selectedowner}
                                btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                                handleSave={handleSave}
                            >
                            <AutoCompleteComponent
                            isOwner = {true}
                            optionSet = {(specificRolePermission?.isAllInvoiceManage ? ownerlist 
                              : specificRolePermission?.isInvoiceTeamManage ? myTeam 
                              : [{
                              firstName: `${currentUser?.firstname}`,
                              lastName : `${currentUser?.lastname}`,
                              id: currentUser?.userId,
                            }]) || []}
                            value={selectedowner|| null}
                            name = "managerId"
                            placeholder={handleValidateCodevalue(internationalise,"INV_REASSIGN_SELECT_OWNER")}
                            disabled = {!(specificRolePermission?.isAllInvoiceManage || specificRolePermission?.isInvoiceTeamManage)}
                            label={handleValidateCodevalue(internationalise,'INV_SEARCH_OWNER')}
                            onChange={(event, Owner) => handleSelectReassignOwner(event, Owner)}
                            />
                                
                            </LeadDialog>
                        )
                        }
    {/* </Box> */}
    </StyledDiv>
    </BiztantuLoader>

  )
}

export default InvoicePage;